import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { EMPTY, Observable, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { ResolverHelper } from "./resolver.helper";
import { SearchMode, SearchStateService } from "src/services/search-state.service";

export const CustomerCheckSearchResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const authService = inject(AuthService);
    const searchStateService = inject(SearchStateService);
    const router = inject(Router);
    const queryParams = route.queryParams;
    const hasIdentity = queryParams.hasOwnProperty("identification");
    let identity: string = null;
    if (hasIdentity) {
        identity = queryParams["identification"] != null ? queryParams["identification"].toString() : "";
    }
    if (identity) {
        return ResolverHelper.hasPermission(authService, EVServiceType.Internal_Debug).pipe(
            switchMap((hasDebugRole) => {
                return ResolverHelper.hasPermission(authService, [EVServiceType.EvWeb_CustomerCheck]).pipe(
                    take(1),
                    switchMap((hasCustomerCheckRole) => {
                        if (hasCustomerCheckRole) {
                            if (hasDebugRole) {
                                searchStateService.setCustomerSearchPersonIdentificationString(identity);
                                router.navigate(["/searchpage"], {
                                    queryParams: {
                                        searchMode: SearchMode.CUSTOMERCHECK,
                                    },
                                });
                            } else {
                                const url =
                                    environment.evwebUrl + "/searchpage?customeridentification=" + encodeURIComponent(identity) + "&dosearch=true&searchMode=3";
                                window.open(url, "_self");
                            }
                            return EMPTY;
                        } else {
                            return ResolverHelper.redirectToFrontPage(authService, router);
                        }
                    }),
                );
            }),
        );
    } else {
        return ResolverHelper.redirectToFrontPage(authService, router);
    }
};
